import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Button,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import ImageServices from "../services/externalServices/imageServices";
import ImageFormDialog from "./ImageFormDialog";

function Images() {
  const [images, setImages] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);

  useEffect(() => {
    getImages();
  }, []);

  const getImages = async () => {
    try {
      const res = await ImageServices.getAllImages();
      console.log("Fetched Images:", res);
      setImages(res);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleOpenDialog = (image) => {
    setSelectedImage(image);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedImage(null);
  };

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    console.log("CloseAddDialog called")
    setOpenAddDialog(false);
  };

  const handleSaveImage = async (imageData) => {
    try {
      if (selectedImage) {
        // If editing an existing image
        await ImageServices.updateImage(selectedImage._id, imageData); // Assuming an updateImage method
        console.log("Updated image:", imageData);
      } else {
        // If adding a new image
        console.log("imageData",imageData)
        await ImageServices.createImages(imageData); // Assuming an addNewImage method
        console.log("New image added:", imageData);
      }
       setOpenDialog(false);
      setOpenAddDialog(false);
       getImages(); // Refresh the image list
    } catch (error) {
      console.error("Error saving image:", error);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenAddDialog}
        sx={{ mb: 2 }}
      >
        Add New Image
      </Button>

      <Grid container spacing={4}>
        {images.length > 0 ? (
          images.map((image) => (
            <Grid item xs={12} sm={6} md={4} key={image._id}>
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={image.image_url}
                  alt={image.title}
                  onClick={() => handleOpenDialog(image)}
                />
                <CardContent>
                  <Typography variant="h6">{image.title}</Typography>
                  <Typography variant="body2">{image.text}</Typography>
                  <Typography variant="body2">Clicks: {image.clicks}</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenDialog(image)}
                    sx={{ mt: 2 }}
                  >
                    Edit
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="h6" sx={{ textAlign: "center", width: "100%" }}>
            No images found
          </Typography>
        )}
      </Grid>

      {/* Reusable Image Form Dialog */}
      <ImageFormDialog
        open={openDialog || openAddDialog}
        onClose={selectedImage ? handleCloseDialog : handleCloseAddDialog}
        onSubmit={handleSaveImage}
        imageData={selectedImage}
        isEditMode={!!selectedImage} // If selectedImage is present, it's edit mode
      />
    </Box>
  );
}

export default Images;
